"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NumberInput = require("./NumberInput");
Object.keys(_NumberInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NumberInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NumberInput[key];
    }
  });
});